export default "__VITE_ASSET__Ct_zuaQ1__"